// Backend zwraca ścieżki logo jako '/public/...' — względne do API
// (admin.racepulse.pl), nie do originu strony wyników, na którym są
// renderowane. Bez tego doklejenia obrazek jest broken image (404).
export const resolveAssetUrl = (path) => {
  if (!path) return path;
  if (/^https?:\/\//i.test(path)) return path;
  return `${process.env.REACT_APP_API_URL}${path.startsWith('/') ? '' : '/'}${path}`;
};
